import { turboFetch } from "../util"

import SelectionTrackingController from "./selection_tracking_controller"

export default class extends SelectionTrackingController {
  static values = {
    key: { type: String, default: "user_ids" },
    method: { type: String, default: "post" }
  }

  initialize() {
    super.initialize()
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  connect() {
    super.connect()
  }

  disconnect() {
    super.disconnect()
  }

  buttonTargetConnected(button) {
    button.addEventListener("click", this.handleOnClick)
  }

  buttonTargetDisconnected(button) {
    button.removeEventListener("click", this.handleOnClick)
  }

  handleOnClick(event) {
    event.preventDefault()

    const button = event.currentTarget
    const buttonMethod = button.dataset.openDrawerMethodParam || this.methodValue

    if (buttonMethod === "get") {
      this.fetchWithGet(button)
    } else {
      this.fetchWithPost(button)
    }
  }

  fetchWithGet(button) {
    const ids = this.idsForButton(button)
    const urlWithIds = this.buildUrlWithIds(button.href, ids)
    turboFetch(urlWithIds, { method: "get" })
  }

  fetchWithPost(button) {
    const ids = this.idsForButton(button)
    const options = {
      method: "post",
      body: JSON.stringify({ [this.keyValue]: ids })
    }

    turboFetch(button.href, options)
  }

  buildUrlWithIds(baseUrl, ids) {
    const url = new URL(baseUrl)
    ids.forEach(id => url.searchParams.append(`${this.keyValue}[]`, id))
    return url.toString()
  }

  idsForButton(button) {
    const fixedIds = button.dataset.openDrawerFixedIdsParam
    return fixedIds ? JSON.parse(fixedIds) : this.selectedIds
  }
}
